import { borrowersAPI } from "services/swagger-api";
import { MainBorrowerPricingState } from "../../types";
import { MainBorrowerPricingSyncActions } from "../types";
import { onAdjustment } from "./onAdjustment";
import { PricingWatchdog } from "../pricingWatchdog";

export const toggleBorrowerLoan = async (
  borrowerLoanId: string,
  actions: MainBorrowerPricingSyncActions,
  getState: () => MainBorrowerPricingState,
  pricingWatchdog: PricingWatchdog
): Promise<void> => {
  try {
    actions.setLoading(true)
    actions.setError(null)

    const { borrowerProjectId, borrowerId } = getState()

    if (borrowerId && borrowerProjectId) {
      const response = await borrowersAPI.toggleBorrowerLoan({
        borrowerLoanId,
      })
      if (response.isSuccess) {
        onAdjustment(actions, getState, pricingWatchdog)
        actions.toggleLoanIsActive(borrowerLoanId)
      }
    }
  } catch (error) {
    actions.setError(error instanceof Error ? error.message : 'Une erreur est survenue')
  } finally {
    actions.setLoading(false)
  }
}
